const DISH_ML_INGREDIENT_TYPE = {
  MAIN_INGREDIENT: 'MAIN_INGREDIENT',
  CHOICE_INGREDIENT: 'CHOICE_INGREDIENT',
}

export default DISH_ML_INGREDIENT_TYPE
